import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "CargarDocsComponent"
  helpContainer: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important'
  },

  container: {
    display: 'grid !important',
    height: '100vh !important',
    zIndex: '8002 !important',
    gridTemplateColumns: '20% 60% 20%',
    // eslint-disable-next-line
    ['@media only screen and (max-width: 600px)']: {
      // gridTemplateColumns: '5% 90% 5%',
      gridTemplateColumns: '100%',
    },
    gridAutoRows: '100vh !important',
    overflowY: 'hidden !important',
    backgroundColor: '#FFFFFF !important'
  },

  continueBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    //margin: theme.spacing(0.5),
    marginBottom: '1vh',
    fontWeight: 'bold',
    border: `1px solid ${theme.palette.primary.main} !important`,
    // width: '90%',
  },

  stageTitle: {
    fontWeight: 600,
    //outline: 'solid 1px tomato !important',
    width: '100%',
    paddingLeft: theme.spacing(1),
  },

  stageSubTitle: {
    // fontWeight: 600,
    //outline: 'solid 1px tomato !important',
    width: '100%',
    paddingLeft: theme.spacing(1),
  },

  stepsTitle: {
    fontSize: 16,
    width: '90% !important',
    paddingLeft: 20,
    paddingRight: 20,
    textAlign: 'left !important',
    ['@media only screen and (max-width: 600px)']: {
      fontSize: 16,
    },
  },
  rootListItems: {
    '&.MuiList-padding': {
      padding: '0px !important'
    }
  },
  rootList: {
    width: '100%',
    height: '65vh !important',
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: theme.palette.background.paper,
    //outline: 'solid 1px green !important',
    overflowY: 'auto',
    // ['@media only screen and (max-width: 600px)']: {
    //   height: '68vh !important',
    // },
    //maxHeight: '70vh !important'
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '60%'
  },
  cargarDocsBtn: {
    width: '100%',
    alignSelf: 'center !important',
    marginBottom: '1px'
  },
  cover: {
    width: 50,
    outline: 'solid 1px blue !important',
  },
  details: {
    display: 'flex',
    outline: 'solid 1px tomato !important',
  },
  content: {
    flex: '1 0 auto',
    outline: 'solid 1px yellow !important',
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    outline: 'solid 1px green !important',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  appBar: {
    backgroundColor: '#FFFFFF'
  },
  help: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#FFFFFF',
    marginLeft: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  helpIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sectionDesktop: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  locationIcon: {
    width: '45px !important',
    height: '45px !important',
    position: 'absolute !important',
    right: '30px !important',
    marginTop: '-25px !important',
    zIndex: '1',
  },
  cargarDocsContainer: {
    position: 'relative !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
  btnContainer: {
    display: 'center !important',
    flexDirection: 'row !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    width: '100% !important',
    //outline: 'solid 1px tomato !important',
  },
  btnHelpContainer: {
    display: 'flex !important',
    flexDirection: 'row !important',
    alignItems: 'center !important',
    justifyContent: 'flex-end !important',
    width: '100% !important',
    //outline: 'solid 1px tomato !important',
  },
  acceptBtn: {
    //margin: theme.spacing(1),
    margin: '4px !important',
  },

  //Biometrics
  title: {
    alignSelf: 'flex-start',
    fontWeight: 600,
  },
  subtitle: {
    alignSelf: 'flex-start',
    marginTop: '10px',
  },
  devicePic: {
    width: '100% !important',
    ['@media only screen and (max-width: 600px)']: {
      height: '20vh !important',
    },
    height: '50vh !important',
    //outline: 'solid 1px tomato !important',
    objectFit: 'scale-down !important'
  },
  enrollmentButtonHelp: {
    width: '100%',
    marginBottom: '1em'
  },
  //HelpDocs Camera

  wizardContainer: {
    display: 'flex',
    height: '90vh',
    width: '100%',
    marginTop: '1vh'
  },
  wizardGif: {
    height: '50%',
    width: '70%',
    marginLeft: '15%',
    alignSelf: 'center !important',
    objectFit: 'scale-down',
    marginTop: '20%'
  },
  captureHelpImg: {
    width: '100%',
    height: '30vh',
    marginTop: '5%',
    objectFit: 'scale-down',
    //outline: 'solid 1px tomato !important',
  },
  wizardTitle: {
    fontSize: '18px',
    fontWeight: 600,
  },
  wizardSubTitle: {
    fontSize: '16px',
    // fontWeight: 600,
  },
  listStyles: {
    padding: 0,
    listStyleType: 'none',
    textAlign: 'left !important',
    width: '100%',
    marginTop: '10px',
    //outline: 'solid 1px tomato !important',
  },

  lineStyle: {
    color: theme.palette.primary.main,
    marginRight: '10px',
  },

  leftColumn: {
    //outline: 'solid 1px tomato !important',
    overflowY: 'none',
    backgroundColor: '#7f7f7f',
    ['@media only screen and (max-width: 600px)']: {
      backgroundColor: '#ffffff',
      display: 'none',
    },
  },
  rightColumn: {
    //outline: 'solid 1px tomato !important',
    overflowY: 'none',
    backgroundColor: '#7f7f7f',
    ['@media only screen and (max-width: 600px)']: {
      backgroundColor: '#ffffff',
      display: 'none',
    },
  },

  // Help Icon 
  helpImage1: {
    // margin: theme.spacing(4),
    margin: '10px !important',
    padding: '10px !important',
    height: '41vh !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '30vh !important'
    },
  },

  closeText: {
    alignSelf: 'flex-end !important',
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(3),
    '&&:focus': {
      outline: 'none !important',
    },
    '@media (max-width: 810px)': {
      marginRight: theme.spacing(0),
      marginTop: theme.spacing(6),
    }

  },

  titlePrincipal: {
    fontWeight: 'bold !important',
    // fontSize: 19,
    marginTop: theme.spacing(1),
    '@media (max-width: 650px)': {
      // fontSize: 16,
    }
  },

  // p:{
  //   '@media (max-width: 650px)': {
  //     fontSize: 14,
  //   }
  // },

  pCerKeyHelp: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    '@media (max-width: 650px)': {
      fontSize: 14,
    }
  },

  modal: {
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: theme.spacing(3),
    '@media (max-width: 650px)': {
      marginRight: theme.spacing(0),
      width: '95%',
    }
  },

  modalInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 650px)': {
      width: '90%',
    }
  },

  helpInstruction: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  helpListInstructions: {
    display: 'flex',
    marginBottom: theme.spacing(1),
  },

  cancelIcon: {
    marginRight: theme.spacing(2),
  },

  //Bottom Drawer
  drawer: {
    marginLeft: '20% !important',
    width: '60% !important',
    borderRadius: '5px 5px 0px 0px !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '5px 24px',
    ['@media only screen and (max-width: 600px)']: {
      marginLeft: '0% !important',
      width: '100% !important',
    },
  },

  drawerCenter: {
    paddingTop: '24px',
    width: '60%',
    ['@media only screen and (max-width: 600px)']: {
      width: '95%',
    },
  },

  drawerTitle: {
    fontWeight: 'bold !important',
    textAlign: 'center !important',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },

  drawerSubTitle: {
    marginBottom: theme.spacing(1),
  },

  radio: {
    margin: 0
  },

  //SeeDocBeforeLoad

  buttonSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '75%',
    ['@media only screen and (max-width: 600px)']: {
      width: '95%',
    },
  },

  docVisual: {
    height: '60vh',
    width: '75%',
    // backgroundColor: theme.palette.secondary.light,
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(1),
    ['@media only screen and (max-width: 600px)']: {
      width: '95%',
      height: '52vh',
    },
  },

  doc: {
    width: '97%',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  },

  mobileDoc: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    width: '100% !important',
    height: '57vh !important',
    overflowY: 'auto !important',
  },

  //Form dynamic
  inputField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: '100%',
    '@media (max-width: 650px)': {
      width: '95%',
    }
  },

  form: {
    width: '67%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '70vh',
    overflowY: 'auto',
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(3),
    '@media (max-width: 650px)': {
      marginRight: theme.spacing(0),
      width: '95%',
      height: '60vh',
    },
    ['@media only screen and (max-height: 814px)']: {
      height: '60vh',
    },
  },

  helpModalTextForm: {
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    '@media (max-width: 650px)': {
      marginBottom: theme.spacing(1),
      width: '90%',
    }
  },

  cargarMetaBtn: {
    width: '70%',
    alignSelf: 'center !important',
    justifySelf: 'flex-start !important',
    marginTop: theme.spacing(3),
    '@media (max-width: 650px)': {
      width: '90%',
    }
  },

  helpModalText: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    '@media (max-width: 650px)': {
      marginBottom: theme.spacing(1),
      width: '100%',
    }
  },

  helpModalTextPreview: {
    width: '74%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    '@media (max-width: 650px)': {
      marginBottom: theme.spacing(1),
      width: '100%',
    }
  },

  helpModalTextCamera: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    '@media (max-width: 650px)': {
      marginBottom: theme.spacing(1),
      width: '100%',
    }
  },

  //QRCloseProcess
  imageSection: {
    height: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageIcon: {
    marginTop: '15% !important',
    width: '50%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '10% !important',
      width: '40%',
    },
  },

  imageHelpContainer: {
    width: '100% !important',
    height: '60vh',
    overflowY: 'auto',
    flexDirection: 'column',
    zIndex: 3,
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    ['@media only screen and (max-width: 812px)']: {
      height: '60vh',
    },
  },

  visorContentPrinc: {
    border: '1px solid #A0A1A2',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    height: '100%',
    width: '100%',
  },
  pdfContentCenter: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    textAlign: 'center',
  },
  helpImageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      height: 'auto',
    }
  },
  textContent: {
    fontWeight: 'bold !important',
    width: '100%',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
    }
  },
  wid100: {
    width: '100% !important',
    textAlign: 'center !important',
    overflow:'hidden',
  },
  inputs: {
    marginTop: theme.spacing(2),
    '& .MuiInput-root': {      
      padding: '2px',
      display: 'flex !important',
      flexDirection: 'column !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      height: '100% !important',
      borderRadius: '8px',
      border: `1px solid ${theme.palette.primary.main} !important`,
    },
    '&& ::before': {
      borderBottomColor: theme.palette.primary.main,
      borderBottom: `0px solid ${theme.palette.primary.main} !important`,
      paddingLeft: '10px',
    },
    '&& ::after': {
      borderRadius: '8px',
      borderBottomColor: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main} !important`,
    },
    '& .MuiInputLabel-animated': {
      paddingLeft: '10px',
      color: `${theme.palette.primary.main} !important`,
    },
    '& .MuiFormLabel-root.mui-focused': {
      color: `${theme.palette.primary.main} !important`,
      paddingLeft: '10px',
    },
    '& .MuiInputBase-input': {
      paddingLeft: '10px',
    }

  },
  insideTextTip: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
    top: '45vh',
    padding: '0.2rem',
    width: '100%',
    zIndex: '1000',
    borderRadius: '5px',
    ['@media only screen and (max-width: 800px)']: {
      top: '40vh',
    },
  },

}))
